import { useStyles } from '@team-griffin/stylr';
import cssSides, { Side } from '@team-griffin/css-sides';
import { headingXxs } from '@ux/type-size';
import { gu2px, Theme, Colorway } from '@uds/theme-utils';
import { modifier } from '@ux/style-utils';
import { imageAspectRatioPercentage } from 'presentation/utils/imageAspectRatioPercentage';
import { ImageAspectRatio } from 'domain/constants/imageAspectRatio';
import { useBreakpoints } from '@ux/responsive';

export default ({
  colorway,
  imageAspectRatio,
  theme: { spacing, palette, typography },
}: {
  colorway: Colorway;
  imageAspectRatio: ImageAspectRatio | undefined;
  theme: Theme;
}) => {
  const { isMinLg } = useBreakpoints();

  return useStyles(
    {
      default: {
        root: {
          position: 'relative',
        },
        illustration: {
          width: gu2px(10, spacing),
        },
        endorse: {
          backgroundColor: palette.primary,
          color: palette.primaryContrast,
          display: 'flex',
          alignItems: 'center',
          height: gu2px(4, spacing),
          maxHeight: gu2px(4, spacing),
          position: 'relative',
          ...cssSides('padding', Side.Y, gu2px(1, spacing)),
        },
        endorseText: {
          ...headingXxs(),
          ...cssSides('padding', Side.X, gu2px(3, spacing)),
          position: 'absolute',
          textOverflow: 'ellipsis',
          overflow: 'hidden',
          whiteSpace: 'nowrap',
          left: 0,
          right: 0,
          lineHeight: 1, // to keep it centered
          fontFamily: typography.display,
        },
        bannerAspect: {
          display: 'flex',
          justifyContent: 'flex-content',
          position: 'relative',
          width: '100%',
          height: 0,
          padding: 0,
          overflow: 'hidden',
          paddingTop: imageAspectRatioPercentage(imageAspectRatio),
          backgroundColor: palette.grey12,
        },
        bannerImage: {
          position: 'absolute',
          minHeight: '100%',
          minWidth: '100%',
          top: '50%',
          transform: 'translateY(-50%)',
          width: '100%',
        },
      },

      isMinLg: {
        endorseText: {
          ...cssSides('padding', Side.X, gu2px(4, spacing)),
        },
      },

      [modifier('colorway', Colorway.PRIMARY)]: {
        endorse: {
          backgroundColor: palette.grey02,
          color: '#fff',
        },
      },

      [modifier('colorway', Colorway.PRIMARY_GRADIENT)]: {
        endorse: {
          backgroundColor: palette.grey02,
          color: '#fff',
        },
      },

      [modifier('colorway', Colorway.HIGHLIGHT)]: {
        endorse: {
          backgroundColor: palette.grey02,
          color: '#fff',
        },
      },
    },
    [{ isMinLg }, { colorway }, { imageAspectRatio }],
  );
};
